import React from 'react';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import { speciesEmoji } from '../../lib/utils';
import styles from './RemovePetModal.module.scss';

export interface RemovePetTarget {
  id: string;
  name: string;
  species?: string | null;
  breed?: { name: string } | null;
  chip?: { id: string } | null;
  device?: { id: string } | null;
}

interface RemovePetModalProps {
  open: boolean;
  onClose: () => void;
  pet: RemovePetTarget | null;
  onConfirm: (petId: string, petName: string) => void;
}

export default function RemovePetModal({ open, onClose, pet, onConfirm }: RemovePetModalProps) {
  if (!pet) {
    return null;
  }

  const { id: petId, name: petName } = pet;

  function handleConfirm() {
    onConfirm(petId, petName);
    onClose();
  }

  const details = [
    pet.breed?.name,
    pet.chip ? 'Chip assigned' : 'No chip',
    pet.device ? 'Device assigned' : 'No device',
  ]
    .filter(Boolean)
    .join(' \u00B7 ');

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Remove {pet.name}?</ModalTitle>
      <ModalSubtitle>This will remove the pet from your rescue&rsquo;s view. CX can restore if needed.</ModalSubtitle>

      <div className={styles.petCard}>
        <div className={styles.petCardContent}>
          <div className={styles.petAvatar}>{speciesEmoji(pet.species)}</div>
          <div>
            <div className={styles.petName}>{pet.name}</div>
            <div className={styles.petDetails}>{details}</div>
          </div>
        </div>
      </div>

      <ModalActions>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Remove Pet
        </Button>
      </ModalActions>
    </Modal>
  );
}
